import { z } from "zod";

export const OffboardingSectionTypeEnum = z.enum([
    "RETENTION",
    "RESIGNATION",
    "EXIT_INTERVIEW",
    "ADMIN_CLEARANCE",
    "IT_CLEARANCE",
    "PAYROLL_CLEARANCE",
    "HR_CLEARANCE",
    "RM_CLEARANCE",
]);

export type OffboardingSectionType = z.infer<typeof OffboardingSectionTypeEnum>;

export const OffboardingQuestionTypeEnum = z.enum([
    "TEXT",
    "RATING",
    "RADIO",
    "CHECKBOX",
    "FILE",
]);
export type OffboardingQuestionType = z.infer<typeof OffboardingQuestionTypeEnum>;

export const OffboardingQuestionSchema = z.object({
    questionId: z.number(),
    question: z.string(),
    questionType: OffboardingQuestionTypeEnum,
    optionsJson: z.string().nullish(),
    mandatory: z.boolean(),
    answer: z.string().nullish(),
    insurancePath: z.string().nullish(),
});

export type OffboardingQuestion = z.infer<typeof OffboardingQuestionSchema>;

export const OffboardingAnswerSchema = z.object({
    questionId: z.number(),
    answer: z.string(),
});

export type OffboardingAnswer = z.infer<typeof OffboardingAnswerSchema>;

export const OffboardingResignationFormSchema = z.object({
    answers: z.array(
        z.object({
            questionId: z.number(),
            answer: z.union([z.string(), z.array(z.string())]),
        }),
    ),
});

export type OffboardingResignationForm = z.infer<typeof OffboardingResignationFormSchema>;

export const OffboardingQuestionnaireSubmitSchema = z.object({
    offboardingId: z.number(),
    sectionType: OffboardingSectionTypeEnum,
    answers: z.array(OffboardingAnswerSchema),
    personalEmail: z.string().trim().email("Enter a valid email").optional(),
});

export type OffboardingQuestionnaireSubmitPayload = z.infer<
    typeof OffboardingQuestionnaireSubmitSchema
>;
